import { makeAutoObservable, runInAction } from "mobx";
import { IdMap } from "../../collections";
export class ProductTypePackagingFeeCreator {
    constructor(params) {
        this.productInstance = null;
        this.packagingFeeTypes = params.packagingFeeTypes;
        this.productTypePackagingFeeAvailabilityService =
            params.productTypePackagingFeeAvailabilityService;
        this._selectedPackagingTypeId = params.selectedPackagingTypeId;
        makeAutoObservable(this);
    }
    setProductInstance(productInstance) {
        this.productInstance = productInstance;
    }
    get possiblePackagingFeeTypes() {
        const { productInstance } = this;
        if (productInstance === null) {
            return IdMap.empty();
        }
        return this.productTypePackagingFeeAvailabilityService.possiblePackagingFeeTypes(productInstance);
    }
    get selectedPackagingFeeTypeId() {
        const possiblePackagingFeeTypes = this.possiblePackagingFeeTypes;
        const possiblePackagingFeeTypeIds = possiblePackagingFeeTypes.ids;
        if (possiblePackagingFeeTypeIds.size === 0) {
            return null;
        }
        if (this._selectedPackagingTypeId !== null &&
            possiblePackagingFeeTypeIds.includes(this._selectedPackagingTypeId)) {
            return this._selectedPackagingTypeId;
        }
        return this.cheapestPackagingFeeTypeId(possiblePackagingFeeTypes);
    }
    cheapestPackagingFeeTypeId(packagingFeeTypes) {
        var _a, _b;
        const sorted = packagingFeeTypes.objects.sorted((a, b) => a.price.cents - b.price.cents).raw;
        return (_b = (_a = sorted[0]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
    }
    choose(packagingFeeId) {
        if (!this.packagingFeeTypes.ids.includes(packagingFeeId)) {
            throw new Error(`ExtraFeeId ${packagingFeeId.toString()} is not supported`);
        }
        runInAction(() => {
            this._selectedPackagingTypeId = packagingFeeId;
        });
    }
}
